export default class FigureCalculator {

    static mean(array) {

        let mean = 0;

        array.forEach(element => mean = mean + element);

        return mean / array.length;
    }

    static variance(array) {

        let variance = 0;
        let mean = this.mean(array);

        array.forEach(element => variance = variance + Math.pow((element - mean), 2));

        return variance / array.length;
    }

    static deviation(array) {
        return Math.sqrt(this.variance(array));
    }

    static trunksPerHectare(sample){

        let trees = sample.trees[0].length
        let area = FigureCalculator.getAreaFromSample(sample)

        return trees / (area/10000)
    }

    static dgv(array) {
        return array.reduce((t, d) => t + Math.pow(d,3), 0) / array.reduce((t, d) => t + Math.pow(d,2), 0)
    }

    static base_area(array, hectare) {
        return array.reduce((tot, tree)=> {
            if (tree.isSample) {
                return tot + Math.PI * Math.pow(tree.diameter / 100 / 2, 2)
            }
            return tot + (Math.PI * Math.pow(tree.diameter / 100 / 2, 2))
        }, 0) / hectare;
    }

    static radiiToHectare(array){
        return this.areaToHectare(this.radiiToArea(array));
    }

    static areaToHectare(area) {
        return area/10000
    }

    static radiiToArea(array) {
        return array.reduce((tot, radius)=> tot + Math.pow(radius, 2)*Math.PI, 0)
    }

    static volume(array, hectare, sampleLatitude) {
        if (!array.length) {
            return 0.0;
        }

        let diameters = array.map(x => x.diameter);
        let heights = array.map(x => x.height);

        let vol = FigureCalculator.voldm3sk(array, sampleLatitude);

        if (vol === "NA") {
            return FigureCalculator.mean(heights) * 0.45 * FigureCalculator.base_area(array, hectare)
        }
        return FigureCalculator.volumePerHA(FigureCalculator.dgv(diameters), vol, FigureCalculator.base_area(array, hectare))
    }

    static voldm3sk(array, sampleLatitude) {

        let dgv = FigureCalculator.dgv(array.map(x => x.diameter)); // dgv in cm.
        let height = FigureCalculator.mean(array.map(x => x.height));

        let vol = 0.0;

        if(dgv < 5 || height < 6) {
            return 0
        }
        if(sampleLatitude > 60) // Norra Sverige
        {
            /**
            * Brandel 1211 100-01
            */
            if(array[0].english_name === "Scots Pine") { // Pine
                vol= Math.pow(10,(-1.20914 + 1.94740 * Math.log10(dgv) - 0.05947*Math.log10(dgv+20) + 1.40958*Math.log10(height) - 0.45810*Math.log10(height-1.3)))
                           
            }
            /**
            * Brandel 1221 100-01
            */
            else if(array[0].english_name === "Norway Spruce") { // Spruce
                vol=Math.pow(10,(-0.79783 + 2.07157 * Math.log10(dgv) - 0.73882*Math.log10(dgv+20) + 3.16332*Math.log10(height) - 1.82622*Math.log10(height-1.3)))
            }
            /**
             * Brandel 1231 200-01
             */
            else if (array[0].english_name === "Silver Birch") // Birch
            {
                vol=Math.pow(10,(-0.44224 + 2.47580 * Math.log10(dgv) - 1.40854*Math.log10(dgv+20) + 5.16863*Math.log10(height) - 3.77147*Math.log10(height-1.3)))
            }
            else {
                return "NA"
            }
        }
        else { // Södra Sverige
            /**
            * Brandel 1111 100-01
            */
            if(array[0].english_name === "Scots Pine") // Pine
            {
                vol=Math.pow(10,(-1.38903 + 1.84493 * Math.log10(dgv) + 0.06563*Math.log10(dgv+20) + 2.02122*Math.log10(height) - 1.010195*Math.log10(height-1.3)))
            }

            /**
            * Brandel 1121 100-01
            */
            else if(array[0].english_name === "Norway Spruce") // Gran
            {
                vol=Math.pow(10,(-1.02039 + 2.00128*Math.log10(dgv) - 0.47473*Math.log10(dgv+20) + 2.87138*Math.log10(height) - 1.61803*Math.log10(height-1.3)))
            }

            /**
            * Brandel 1131 200-01
            */
            else if (array[0].english_name === "Silver Birch") // Birch
            {
                vol = Math.pow(10, (-0.89359 + 2.27954*Math.log10(dgv) - 1.18672*Math.log10(dgv+20) + 7.07362*Math.log10(height) - 5.45175*Math.log10(height-1.3)))
            }
            else {
                return "NA"
            }
        }
        return vol
    }

    static volumePerHA (dgv, vol, base_area) {
        // Volträd i dm3sk omvandlas till m3sk, DGV1 är i centimeter, GY1 är i meter
        let dgv_meter = dgv / 100;
        let tree_base_area = (Math.PI * Math.pow(dgv_meter,2)) / 4;
        return (base_area / tree_base_area * vol / 1000)
    }

    static m3fub(trees, hectare, latitude) {
        if (trees.length === 0) {
            return 0
        }

        let m3vol = this.volume(trees, hectare, latitude) / 1000; // dm3 -> m3
        let dgv = this.dgv(trees) * 10; // cm -> mm
        
        return this.mfubConverter(dgv, trees, trees[0].english_name) * m3vol;
    }

    static mfubConverter(dgv, treeType) {

        if (treeType === "Scots Pine") { // Tall

            return 1.96805-56.41423/dgv-0.16104*Math.log(dgv)
        }
        if (treeType === "Norway Spruce"){ // Gran

            return (1.21353-20.70718/dgv-0.04833*Math.log(dgv))
        }
        if (treeType === "Silver Birch") { // Birch

            return (0.46569-6.27221/dgv+0.06662*Math.log(dgv))
        }
        if (treeType === "Lav"){ // Lov

            return (0.34243-0.16246/dgv+0.08378*Math.log(dgv))
        }
        if (treeType === "Contorta"){ // Contorta

            return (0.45420+2.31118/dgv+0.06935*Math.log(dgv))
        }
        else {
            return 0.83
        }
    }

    static meanTrunk(trees, hectare, latitude) {
        return this.m3fub(trees, hectare, latitude) / (trees.length / hectare)
    }

    static getHectareFromSamples(samples) {
        return this.areaToHectare(this.getAreaFromSamples(samples))
    }

    static getAreaFromSamples(samples) {
        return samples.reduce((tot, sample)=> tot + this.getAreaFromSample(sample), 0)
    }

    static getAreaFromSample(sample) {
        if (sample.measure_method_type === 1 || sample.measure_method_type === undefined) {
            return (Math.pow(sample.sample_radius, 2)*Math.PI)
        } else {
            let width = 4
            if (sample.app_version != undefined) {
                let version = sample.app_version.split(".")
                if ((version[0] >= 2 && version[1] >= 18) || version[0] >= 3) {
                    if (sample.sample_radius != undefined) {
                        width = sample.sample_radius * 2
                    }
                }
            }
            return sample.belt_max_distance * width * (1 + (1 / (2 * sample.trees[0].length)));
        }
    }

}
